(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("02AXE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $007cdbb55a906322$export$6503ec6e8aabbaf; }, function (v) { return $007cdbb55a906322$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $007cdbb55a906322$export$f7ad0328861e2f03; }, function (v) { return $007cdbb55a906322$export$f7ad0328861e2f03 = v; });
var $007cdbb55a906322$export$6503ec6e8aabbaf;
var $007cdbb55a906322$export$f7ad0328861e2f03;
"use strict";
var $007cdbb55a906322$var$mapping = new Map();
function $007cdbb55a906322$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$007cdbb55a906322$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $007cdbb55a906322$var$resolve(id) {
    var resolved = $007cdbb55a906322$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$007cdbb55a906322$export$6503ec6e8aabbaf = $007cdbb55a906322$var$register;
$007cdbb55a906322$export$f7ad0328861e2f03 = $007cdbb55a906322$var$resolve;

});

parcelRegister("aztVG", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7b2463a3da6c888b$export$bdfd709ae4826697; }, function (v) { return $7b2463a3da6c888b$export$bdfd709ae4826697 = v; });
var $7b2463a3da6c888b$export$bdfd709ae4826697;
var $7b2463a3da6c888b$export$c9e73fbda7da57b6;
var $7b2463a3da6c888b$export$5a759dc7a1cfb72a;
"use strict";
var $7b2463a3da6c888b$var$bundleURL = {};
function $7b2463a3da6c888b$var$getBundleURLCached(id) {
    var value = $7b2463a3da6c888b$var$bundleURL[id];
    if (!value) {
        value = $7b2463a3da6c888b$var$getBundleURL();
        $7b2463a3da6c888b$var$bundleURL[id] = value;
    }
    return value;
}
function $7b2463a3da6c888b$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7b2463a3da6c888b$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7b2463a3da6c888b$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7b2463a3da6c888b$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7b2463a3da6c888b$export$bdfd709ae4826697 = $7b2463a3da6c888b$var$getBundleURLCached;
$7b2463a3da6c888b$export$c9e73fbda7da57b6 = $7b2463a3da6c888b$var$getBaseURL;
$7b2463a3da6c888b$export$5a759dc7a1cfb72a = $7b2463a3da6c888b$var$getOrigin;

});

var $a52cbc718c97b278$exports = {};


(parcelRequire("02AXE")).register((parcelRequire("aztVG")).getBundleURL("7lpHJ"), JSON.parse('["7lpHJ","index.0842f319.js","94Ba5","About.0a6e151a.js","2GiD0","Typography.0ccb97ee.js","61l1U","Divider.6554190f.js","EOwZl","Button.28bf6689.js","jQIKJ","Button.b6945716.js","qJwA7","ContentPaper.f0ce1526.js","ayOCM","Paper.02d18f71.js","PmNul","ContentPaper.604271f2.css","8ncJs","Projects.6cee2f68.js","dpnv0","OpenInNew.5c5942cd.js","3IlA0","Article.aa3375e1.js","2gvPu","Grid2.430b32db.js","iK0vz","Chips.54347aba.js","hBmGK","Chip.94eeebb2.js","3qSNI","dist.b9e844bd.js","iC6Tl","ConsentBanner.d9d83cd2.js","hC7te","Security.d5dca3c8.js","4GTgi","GppGood.326e2e38.js","e1jUe","GppBad.76082ec5.js","5n8Xl","DataObject.2c89c8a2.js","9VLgF","Timeline.55c2a15a.js","dEMs5","TimelineItem.9cd618e5.js","fugdx","TimelineSeparator.060321ee.js","5FdUF","TimelineConnector.043c52f3.js","2UYVk","FormControlLabel.23204431.js","8Aewo","FormGroup.52f5fc7a.js","9DOQI","Box.928cc4ef.js","lEwBE","ButtonGroup.6c350e9b.js","gwQJo","TimelineDot.7635c5dc.js","239zz","AccessTime.705d46e3.js","32bdb","School.bb623363.js","9Tp0M","EmojiEvents.88b79f79.js","2Gx3L","Celebration.ee912123.js","kCsxZ","Lightbulb.f273094e.js","le6o9","Work.42b4ab3e.js","hWF5o","track.77433928.png","76tkL","autonomous-driving.82f04c0f.pdf","hqZ13","wbs-1.6e2794df.png","lUyIK","wbs-2.2d3d53d9.png","4OI7E","wbs-3.2bce1c2f.png","BpmZs","wbs-4.0b1ca3f4.png","gCdid","main-seminar-1.3b77dc3d.png","6xYK8","main-seminar.9434777d.pdf","jrsWr","scholarship-1.63e48731.jpg","iXNPf","minecraft-plugin-1.0f5c7f4c.png","9XHSw","cursor.3a43610b.jpeg","5uWs0","thesis.53420b4c.pdf","hthkq","Imprint.7c6fabd7.js","839DH","bg-light.7952c70f.png","lvVLz","bg-dark.eb61a23f.png","l1kpY","BasicInformation.31f0628b.js","fjLOL","me.67baa0cb.jpg","iZReD","SocialLinks.035df82f.js","2gkZb","Container.c6d360fc.js","3nzU7","Tooltip.1698f51a.js","gAhUd","Tooltip.ed56208c.js","4yGMG","GitHub.81078aee.js","jPMom","LinkedIn.a92f6b4b.js","27GBf","Instagram.c028d8f1.js","33Tur","Email.9c19f92c.js","i6KnK","Avatar.af15201a.js","cLQMU","Navbar.84931346.js","fmDvW","Brightness7.26a6dfe9.js","ftXj6","Brightness4.d3f8ad38.js","kuUeW","CssBaseline.bf024314.js","fgaRB","GlobalStyles.77ef4200.js","3bIeS","index.71da1d73.css"]'));

})();
//# sourceMappingURL=index.runtime.5fab32e4.js.map
